/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AskIndexRequest = {
  /**
   * The natural language question to ask the index
   */
  question: string;
  /**
   * Reserved for future use - conversation thread identifier
   */
  threadId?: string | null | undefined;
};

/** @internal */
export const AskIndexRequest$inboundSchema: z.ZodType<
  AskIndexRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  question: z.string(),
  thread_id: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "thread_id": "threadId",
  });
});

/** @internal */
export type AskIndexRequest$Outbound = {
  question: string;
  thread_id?: string | null | undefined;
};

/** @internal */
export const AskIndexRequest$outboundSchema: z.ZodType<
  AskIndexRequest$Outbound,
  z.ZodTypeDef,
  AskIndexRequest
> = z.object({
  question: z.string(),
  threadId: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    threadId: "thread_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace AskIndexRequest$ {
  /** @deprecated use `AskIndexRequest$inboundSchema` instead. */
  export const inboundSchema = AskIndexRequest$inboundSchema;
  /** @deprecated use `AskIndexRequest$outboundSchema` instead. */
  export const outboundSchema = AskIndexRequest$outboundSchema;
  /** @deprecated use `AskIndexRequest$Outbound` instead. */
  export type Outbound = AskIndexRequest$Outbound;
}

export function askIndexRequestToJSON(
  askIndexRequest: AskIndexRequest,
): string {
  return JSON.stringify(AskIndexRequest$outboundSchema.parse(askIndexRequest));
}

export function askIndexRequestFromJSON(
  jsonString: string,
): SafeParseResult<AskIndexRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AskIndexRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AskIndexRequest' from JSON`,
  );
}
